import { ReactNode } from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import { Button } from 'framework/ui/mui-builder';

type AssignmentsBlockHeaderVariant = 'dashboard' | 'staffing';

interface AssignmentsBlockHeaderProps {
  assignmentsFilters: ReactNode;
  onRequestVacancy: () => void;
  variant?: AssignmentsBlockHeaderVariant;
}

const AssignmentsBlockHeader = ({
  assignmentsFilters,
  onRequestVacancy,
  variant = 'dashboard',
}: AssignmentsBlockHeaderProps) => {
  const isStaffing = variant === 'staffing';

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      pl={isStaffing ? 2 : undefined}
    >
      <Grid size={isStaffing ? 2 : 2.4}>
        <Typography variant="h4" color="primary">
          Assignments
        </Typography>
      </Grid>

      <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { m: 0 } }}>
        {assignmentsFilters}
      </Grid>

      <Grid size="grow" />

      <Grid size={3} display="flex" justifyContent="flex-end">
        <Button variant="text" onClick={onRequestVacancy}>
          <Add color="primary" sx={{ fontSize: '12px' }} />

          <Typography variant="body1" color="primary">
            Request vacancy
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export default AssignmentsBlockHeader;
